module.exports = __webpack_public_path__ + "img/icons/new/link-pg-761e097fa01bb0f1836b9d2a579808d3.svg";